export const props = {
  // Values
  icon: String,
  title: String,
  text: String,
  actions: Array,

  // Options
  color: {
    type: String,
    default: 'basic'
  },
  dense: {
    type: Boolean,
    default: false
  }
}
